import React, { useEffect } from 'react'
import {
  deletePartnerOffer,
  fetchPartnerOffers,
} from 'actions/views/shops'
import useAction from 'utils/useAction'
import {
  getCurrentShopId,
  getIsPartnerOffersLoaded,
  getPartnerOffers,
  getPartnerOffersFilters,
  getPartnerOffersPage,
  getPartnerOffersPageCount,
  getPartnerOffersSorter,
  getIsSavingActive,
  getIsPartnerOffersDataFilteredOrSorted,
} from 'domains/shops/selectors'
import { useSelector } from 'react-redux'
import { Button, Spin } from 'antd'
import { Buttons, StyledTable } from '../Shops.styles'
import { getRegularRowClass, getRowKey } from 'helpers/tables'
import getColumns from './partnerOffersColumns'
import { openConfirmModal, openPartnerOfferModal, openShopOffersModal } from 'reducers/modals/actions'
import { setShopOfferForEdit } from 'domains/shops/actions'
import { FIELD_NAMES } from 'const/forms'
import { PAGE_SIZE } from '../../../const/tables'

const PartnerOffersTab = () => {
  const currentShopId = useSelector(getCurrentShopId)
  const partnerOffers = useSelector(getPartnerOffers)
  const pageCount = useSelector(getPartnerOffersPageCount)
  const filters = useSelector(getPartnerOffersFilters)
  const sorter = useSelector(getPartnerOffersSorter)
  const page = useSelector(getPartnerOffersPage)
  const isLoaded = useSelector(getIsPartnerOffersLoaded)
  const isSavingActive = useSelector(getIsSavingActive)

  const fetchPartnerOffersFunc = useAction(fetchPartnerOffers)
  const openPartnerOfferModalFunc = useAction(openPartnerOfferModal)
  const deletePartnerOfferFunc = useAction(deletePartnerOffer)
  const openConfirmModalFunc = useAction(openConfirmModal)
  const openShopOffersModalFunc = useAction(openShopOffersModal)
  const setShopOfferForEditFunc = useAction(setShopOfferForEdit)

  const isDataFilteredOrSorted = useSelector(
    getIsPartnerOffersDataFilteredOrSorted
  )

  const paginationConfig = {
    position: ['bottomCenter'],
    showQuickJumper: true,
    total: pageCount * PAGE_SIZE,
    pageSize: PAGE_SIZE,
    current: page,
    showSizeChanger: false,
  }

  const handleResetFilters = () => {
    fetchPartnerOffersFunc({
      filters: {},
      sorter: {},
      page: 1,
    })
  }

  const handleDeletePartnerOffer = (offer) => {
    const callback = () => deletePartnerOfferFunc(offer[FIELD_NAMES.id])
    const text =
      `Are you sure you want to delete partner offer (ID: ${
        offer[FIELD_NAMES.id]
      })? ` + "This action can't be revoked."
    openConfirmModalFunc({ callback, text })
  }

  const onTableChange = (pagination, filters, sorter) => {
    fetchPartnerOffersFunc({
      page: pagination.current,
      filters,
      sorter,
    })
  }

  const handleEditOffer = (id) => {
    openPartnerOfferModalFunc({ id })
  }

  const handleEditShopOffer = (offer) => {
    const shopOfferData = offer.attributes?.shop_offer_data
    if (shopOfferData) {
      setShopOfferForEditFunc(shopOfferData)
      openShopOffersModalFunc({ id: offer.attributes.shop_offer_id })
    }
  }

  const handleCreateOffer = () => {
    openPartnerOfferModalFunc()
  }

  useEffect(() => {
    if (currentShopId) fetchPartnerOffersFunc()
  }, [currentShopId])

  return (
    <Spin spinning={isSavingActive} size="large">
      <Buttons>
        <Button
          onClick={handleResetFilters}
          disabled={!isLoaded || !isDataFilteredOrSorted}
          style={{ marginLeft: '12px' }}
        >
          Reset filters
        </Button>

        <Button
          onClick={handleCreateOffer}
          disabled={!currentShopId}
          style={{ marginRight: '12px' }}
        >
          Create partner offer
        </Button>
      </Buttons>

      <StyledTable
        onChange={onTableChange}
        dataSource={partnerOffers}
        columns={getColumns(
          filters,
          sorter,
          handleEditOffer,
          handleDeletePartnerOffer,
          handleEditShopOffer
        )}
        size="medium"
        pagination={paginationConfig}
        rowKey={getRowKey}
        rowClassName={getRegularRowClass}
        bordered
        sticky={isLoaded}
        scroll={{ x: 'max-content' }}
      />
    </Spin>
  )
}

export default PartnerOffersTab
